import type { PropsWithChildren } from 'react';
import { VStack } from '../../Core';

export const BalanceDetails = ({ children }: PropsWithChildren) => (
  <VStack gap="spacing8" alignItems="space-between" fontSize="fontSizeSmall">
    {children}
  </VStack>
);
